import { comparerByAlphabet } from '@app/comparers';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import { CountryDepartment } from '@app/models/country-department';
import {
    CountryDepartmentActionTypes,
    CountryDepartmentActionsUnion
} from '@core/actions/country-department.action';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface State extends EntityState<CountryDepartment> {
    loading: boolean;
    loaded: boolean;
    loadedBusiness: any[];
    filteredCountryDeparmentIds: any[];
}

export const adapter: EntityAdapter<CountryDepartment> = createEntityAdapter<
    CountryDepartment
>({
    selectId: (countryDepartment: CountryDepartment) => countryDepartment.id,
    sortComparer: comparerByAlphabet('ASC', 'name')
});

export const INITIAL_STATE: State = adapter.getInitialState({
    loading: false,
    loaded: false,
    loadedBusiness: [],
    filteredCountryDeparmentIds: []
});

export function reducer(
    state: State = INITIAL_STATE,
    action: CountryDepartmentActionsUnion
) {
    switch (action.type) {
        case CountryDepartmentActionTypes.Load:
            return {
                ...state,
                loading: true,
                loadedBusiness: [...state.loadedBusiness, action.dataFilter]
            };

        case CountryDepartmentActionTypes.LoadPlanner:
            return {
                ...state,
                loading: true,
                loadedBusiness: [...state.loadedBusiness, action.dataFilter]
            };
        case CountryDepartmentActionTypes.LoadbyProduct:
        case CountryDepartmentActionTypes.updateHierarchy:
            return { ...state, loading: true };

        case CountryDepartmentActionTypes.LoadFail:
        case CountryDepartmentActionTypes.LoadbyProductFail:
        case CountryDepartmentActionTypes.updateHierarchySuccess:
        case CountryDepartmentActionTypes.updateHierarchyFail:
            return { ...state, loading: false };

        case CountryDepartmentActionTypes.LoadSuccess:
            return adapter.upsertMany(action.countryDepartments, {
                ...state,
                loading: false,
                loaded: true
            });


        case CountryDepartmentActionTypes.LoadPlannerSuccess:
            return adapter.addAll(action.countryDepartments, {
                ...state,
                loading: false,
                loaded: true
            });
        case CountryDepartmentActionTypes.LoadbyProductSuccess:
            return adapter.addAll(action.countryDepartments, {
                ...state,
                loading: false,
                loaded: true
            });

        case CountryDepartmentActionTypes.Search:
            return {
                ...state,
                filteredCountryDeparmentIds: [],
                loading: true
            };

        case CountryDepartmentActionTypes.SearchSuccess:
            return {
                ...state,
                filteredCountryDeparmentIds:
                    action.countryDepartmentsIds.length === 0
                        ? [-1]
                        : action.countryDepartmentsIds,
                loading: false
            };

        case CountryDepartmentActionTypes.SearchFail:
            return {
                ...state,
                filteredCountryDeparmentIds: [],
                loading: false
            };

        case CountryDepartmentActionTypes.ClearSearch:
            return {
                ...state,
                filteredCountryDeparmentIds: [],
                loading: false
            };

        case CountryDepartmentActionTypes.Create:
            return { ...state, creating: true };

        case CountryDepartmentActionTypes.CreateFail:
            return { ...state, creating: false };

        case CountryDepartmentActionTypes.CreateSuccess:
            return adapter.addOne(action.countryDepartment, {
                ...state,
                creating: false
            });

        case CountryDepartmentActionTypes.UpdateSuccess:
            return adapter.upsertOne(action.countryDepartment, state);

        case CountryDepartmentActionTypes.DeleteSuccess:
            const CountryDepartmentId = action.CountryDepartmentId;

            return adapter.removeOne(CountryDepartmentId, state);

        case CountryDepartmentActionTypes.Clear:
            // state = undefined;
            return INITIAL_STATE;

        case CountryDepartmentActionTypes.LoadById:
            return { ...state, loading: true };

        case CountryDepartmentActionTypes.LoadByIdSuccess:
            let newFiltered = []
            if (state.filteredCountryDeparmentIds.length > 0) {

                let newData = state.filteredCountryDeparmentIds.filter(item => item.id === action.CategoryId)[0] = {
                    id: action.CategoryId,
                    ...action.data
                }
                newFiltered.push(newData)
                let currentData = state.filteredCountryDeparmentIds.filter(item => item.id !== action.CategoryId)
                newFiltered.push(...currentData)
            }

            return adapter.updateOne({ id: action.CategoryId, changes: action.data },
                {
                    ...state,
                    filteredCountryDeparmentIds: newFiltered
                })

        case CountryDepartmentActionTypes.LoadByIdFail:
            return { ...state, loading: false };

        default:
            return state;
    }
}

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const selectCountryDepartmentIds = (state: State) =>
    state.filteredCountryDeparmentIds;
const selectLoadedBusiness = (state: State) => state.loadedBusiness;
export const getState = createFeatureSelector<State>('countryDepartments');
export const getFilteredCountryDepartmentIds = createSelector(
    getState,
    selectCountryDepartmentIds
);
export const getAll = createSelector(
    getState,
    selectAll
);

export const getStateLoadedBusiness = createSelector(
    getState,
    selectLoadedBusiness
);

export const getOnlyN1 = createSelector(
    getAll,
    countryDepartments => {
        return countryDepartments.filter(cd => cd.level === 5);
    }
);
